<template>
	<div class="border-top">
		<SOFilterTitle :title="'Layanan Terhubung'" :diterapkan="diterapkan" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" style="display: none" :id="id">
			<SOFilterCheckboxSkeleton v-if="pageSetting.loading"/>
			<SOInputCheckbox
				:checkboxes="layananTerhubung"
				:checked="filterItem.layananTerhubung"
				:limit-loop="true"
				:limit-loop-count="5"
				:modal-id="'more-layanan-terhubung'"
				:modal-title="'Layanan Terhubung'"
				@selected="selected"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOFilterCheckboxSkeleton from "@/so-components/global/filter/skeleton/SOFilterCheckboxSkeleton";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
	name: "SOFilterLayananTerhubung",
	components: {
		SOFilterTitle,
		SOFilterCheckboxSkeleton,
		SOInputCheckbox,
	},
	props: {
		id: String,
		idcustomer: String,
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		}),
		...mapGetters("layananModule", {
			listLayanan: "getListLayananKonsumen",
		})
	},
	data() {
		return {
			layananTerhubung: {
				name: "layanan-terhubung",
				data: []
			},
			pageSetting: {
				loading: true,
			},
			diterapkan: false
		}
	},
	watch: {
		"filterItem.paketKedaluarsa": {
			handler: function (kedaluarsa) {
				this.getLayananKonsumen(kedaluarsa)
			},
			deep: true,
			immediate: true
		},
	},
	mounted() {
		this.diterapkan = this.filterItem.layananTerhubung.length > 0
	},
	methods: {
		async getLayananKonsumen(kedaluarsa) {
			this.layananTerhubung.data = []
			let temp = this.filterItem
			temp.layananTerhubung = []
			this.$store.commit("filterGlobalModule/setFilterItem", temp)

			this.pageSetting.loading = true
			const res = await this.$store.dispatch("layananModule/fetchListLayananKonsumen", {
				idcustomer: this.idcustomer,
				kedaluarsa: kedaluarsa
			})
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}

			this.listLayanan.data.forEach(data => {
				this.layananTerhubung.data = [...this.layananTerhubung.data, {
					id: "flt-" + data.idlayanan,
					value: data.idlayanan,
					title: data.nama_layanan + " <div class='f-12 f-c-black'>(Outlet " + data.nama_outlet + " )</div>",
					checked: false,
					titleBold: false,
				}]
			})
		},
		selected(val) {
			let temp = this.filterItem
			temp.layananTerhubung = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan = this.filterItem.layananTerhubung.length > 0
		}
	},
	beforeDestroy() {
		this.$store.commit("layananModule/resetListLayananKonsumen")
	}
}
</script>